module.exports = __webpack_public_path__ + "media/Uma pessoa mais velha deve sempre ser.9ac6bd42.mp3";